













































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import { TypeCreneau } from "@/api/models/typesCreneau/typeCreneau";
import CreateTypeCreneau from "./CreateTypeCreneau.vue";
import UpdateTypeCreneau from "./EditTypeCreneau.vue";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BAlert,
} from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BAlert,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    CreateTypeCreneau,
    UpdateTypeCreneau,
  },
})
export default class ListTypesCreneau extends Vue {
  perPage = 10;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  isAddNewTypeCreneauSidebarActive = false;
  isUpdateTypeCreneauSidebarActive = false;
  selectedTypeCreneauId = "";
  searchQuery = "";
  timeout: any = null;

  tableColumns = [{ key: "libelle", sortable: true, label: "libellé" }, { key: "actions" }];
  paginatedListTypesCreneau = new PaginatedList<TypeCreneau>();

  async created() {
    await this.loadListTypesCreneau({
      search: this.searchQuery,
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListTypesCreneau.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListTypesCreneau.items.length
    );
  }

  @Watch("currentPage")
  @Watch("perPage")
  async paginationChanged() {
    await this.loadListTypesCreneau({
      search: this.searchQuery,
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  selectTypeCreneau(typeCreneauId: string) {
    this.$router.push({
      name: "details-type-creneau",
      params: { id: typeCreneauId },
    });
  }

  editTypeCreneau(typeCreneauId: any) {
    this.selectedTypeCreneauId = typeCreneauId;
    this.isUpdateTypeCreneauSidebarActive = true;
  }

  @Watch('searchQuery')
  async searchTypesCreneau() {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListTypesCreneau({
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        search: this.searchQuery,
      })
    }, 1000);
  }

  async loadListTypesCreneau(params: any) {
    if (!params || params?.reset) {
      this.paginatedListTypesCreneau = new PaginatedList<TypeCreneau>();
    }
    await this.$http.myressif.typesCreneau
      .paginatedList(params?.search, params?.pageNumber ?? 1, params?.pageSize ?? 10)
      .then((response: PaginatedList<TypeCreneau>) => {
        this.paginatedListTypesCreneau = response;
      });
  }

  askDelete(id: string) {
    this.$bvModal
      .msgBoxConfirm("Etes-vous sûr de vouloir supprimer ce type de créneau ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDelete(id);
        } else {
          return;
        }
      });
  }

  async confirmDelete(id: string) {
    await this.$http.myressif.typesCreneau
      .delete(id)
      .then(
        async (response: string) => {
          successAlert.fire({
            title: "Suppression d'un type de créneau",
            text: "Suppression effectuée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-typesCreneau");
        this.loadListTypesCreneau({
          search: this.searchQuery,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
        });
      });
  }
}
